// extracted by mini-css-extract-plugin
export default {"recruiterContainer":"ITg0kFbxFq_BNgpEKjhF","offerTitle":"D6XrLCRu4eEECQamLr4h","trashIcon":"zkIVyztzqyNf0iQaRmVD","emoji":"SKVyjnmptVLmZ0nPD0rc"};